
import _ from 'underscore';

class ProviderBootstrapDataStore {
  constructor() {
  // eslint-disable-next-line no-undef
    this.providerBootstrapDataMap = new Map();
  }

  addProviderBootstrapData(key, data) {
    this.providerBootstrapDataMap.set(key, data);
  }

  getProviderBootstrapData(key) {
    return Promise.resolve(this.providerBootstrapDataMap.get(key));
  }

  containsProviderBootstrapData(key) {
    return !_.isUndefined(this.providerBootstrapDataMap.get(key));
  }
}
export const providerBootstrapDatastore = new ProviderBootstrapDataStore();
// For GetStoreBootstrapDataV3 API
export const newProviderBootstrapDatastore = new ProviderBootstrapDataStore();
